var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_545_8015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.86084,
    y: 0.341064,
    width: 22.6682,
    height: 22.6682,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_545_8015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47269 20.1757C6.95321 20.1757 6.5085 19.9908 6.13857 19.6208C5.76864 19.2509 5.58367 18.8062 5.58367 18.2867V6.00809H4.63916V4.11907H9.3617V3.17456H15.0288V4.11907H19.7513V6.00809H18.8068V18.2867C18.8068 18.8062 18.6218 19.2509 18.2519 19.6208C17.882 19.9908 17.4373 20.1757 16.9178 20.1757H7.47269ZM16.9178 6.00809H7.47269V18.2867H16.9178V6.00809ZM9.3617 16.3977H11.2507V7.8971H9.3617V16.3977ZM13.1397 16.3977H15.0288V7.8971H13.1397V16.3977Z",
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGrey);
export default __webpack_public_path__ + "static/media/delete_icon_grey.a8ab0474646038679d3b32f217d0e4fa.svg";
export { ForwardRef as ReactComponent };